"use client";

import ShieldCheckIcon from "@repo/ui-system/icons/buttons/shield-v/outline.svg";
import BubbleChatIcon from "@repo/ui-system/icons/random/bubble-chat/outline.svg";
import SmartBrainIcon from "@repo/ui-system/icons/random/smart-brain/outline.svg";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { withBasePath } from "@/lib/base-path";
import { cn } from "@/lib/utils";

const content = {
  title: "How do we rank?",
  description:
    "What guides our picks - 3 key things behind every product we choose:",
  items: [
    {
      icon: SmartBrainIcon,
      title: "Powerful technology",
      description:
        "We scan thousands of products and reviews from trusted sources like Amazon and social media, analyzing real experiences to recommend top options based on price, quality, and overall value",
    },
    {
      icon: BubbleChatIcon,
      title: "Careful review",
      description:
        "Our team ensures quality, value, and fit based on real user feedback",
    },
    {
      icon: ShieldCheckIcon,
      title: "Trusted insights",
      description:
        "We combine AI and human insights to  guide your decisions, reflecting what matters most to people like you.",
    },
  ],
};

type Props = {
  className?: string;
};

export function HowWeRankAccordion({ className }: Props) {
  return (
    <div
      className={cn(
        "rounded-lg border border-[#CCD8FF] bg-[#F5F7FF] px-4 pt-5 pb-1",
        className,
      )}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={withBasePath("/how-we-rank.svg")}
        alt="How we rank illustration"
        className="w-full h-[112px] object-cover object-bottom mb-3"
      />

      <div>
        <h3 className="mb-2 text-text-grayscale-subtitle">{content.title}</h3>
        <p className="body1 text-text-grayscale-body">{content.description}</p>
      </div>

      <Accordion
        type="single"
        collapsible
      >
        {content.items.map((item, idx) => {
          const Icon = item.icon;
          return (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="py-4"
            >
              <AccordionTrigger className="py-0 items-center text-text-grayscale-caption hover:text-primary-hover transition-colors duration-150 ease-in-out">
                <div className="flex items-center gap-2">
                  <Icon
                    aria-hidden="true"
                    className="size-7 p-1 bg-surface-primary-lighter rounded text-elements-primary-darker shrink-0"
                  />
                  <span className="mini1 text-left">{item.title}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="py-0">
                <p className="body1 text-text-grayscale-body ps-9 pe-4 text-left">
                  {item.description}
                </p>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
}
